import {
  mapGetters,
} from 'vuex';

export default {
  name: 'AppointmentOverview',
  components: {},
  props: {},
  data: () => ({

  }),
  computed: {
    ...mapGetters('appointment', {
      serviceType: 'getServiceType',
      tireType: 'getTireType',
      tireLocations: 'getTireLocations',
      tireStock: 'getTireStock',
      bodyworkType: 'getBodyworkType',
    }),
    hasAtLeast1NewTire() {
      let hasActiveTire = false;
      const tireLocations = ['t1l1', 't1r1', 't2l2', 't2l1', 't2r1', 't2r2'];

      tireLocations.forEach(tireLocation => {
        const stockProperty = `${this.tireType}Stock`;
        const stockState = this.tireLocations[tireLocation][stockProperty];
        // 2 active
        if (stockState === 2) {
          hasActiveTire = true;
        }
      });

      return hasActiveTire;
    },
    hasAtLeast1StockTire() {
      const tireStock = this.tireStock[this.tireType];
      const residualStockCar = ((tireStock * 100) / 4) / 100;
      const residualStockBus = ((tireStock * 100) / 6) / 100;

      return (this.bodyworkType === 'car' && residualStockCar > 0 && residualStockCar < 1) ||
        (this.bodyworkType === 'bus' && residualStockBus > 0 && residualStockBus < 1);
    },
  },
  methods: {},
};
